import React from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@components/ui/Breadcrumbs";

const BreadcrumbsWrapper = ({ breadcrumbsData }) => {
  return (
    <Breadcrumb className="">
      <BreadcrumbList className="gap-2 flex items-center">
        {breadcrumbsData.map((item, index) => (
          <React.Fragment key={index}>
            <BreadcrumbItem className="gap-2 inline-flex items-center">
              {item.isActive ? (
                <span className="text-text-primary hover:underline hover:cursor-pointer text-web-b2-body-2 font-akkurat">
                  {item.label}
                </span>
              ) : (
                <BreadcrumbLink 
                  href={item.href}
                  className="text-web-l2-link-2 text-text-secondary hover:cursor-pointer hover:underline  font-akkurat hover:text-text-primary-hover"
                >
                  {item.label}
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
            {index < breadcrumbsData.length - 1 && (
              <BreadcrumbSeparator className="text-web-b2-body-2 text-text-secondary" />
            )}
          </React.Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default BreadcrumbsWrapper; 